$('.js-sticky-widget').fix({
    startOffset: 20,
    until: '.js-sticky-until',
    stopEarly: 386
})